import axios from '../../../../utills/axiosConfig';


export const fetchRoles = async () => {
  const res = await axios.get('/roles');
  return res.data;
};

export const addRole = async (role) => {
  const res = await axios.post('/roles', role);
  return res.data;
};

export const updateRole = async (id, role) => {
  const res = await axios.put(`/roles/${id}`, role);
  return res.data;
};

export const deleteRole = async (id) => {
  const res = await axios.delete(`/roles/${id}`);
  return res.data;
};
